import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, TransitionGroup as _TransitionGroup, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "toasts-list" };
import { transitionHook } from "../utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Toasts',
    props: {
        teleport: { type: [String, Object], default: function () { return document.body; } },
    },
    setup: function (__props) {
        var leave = transitionHook(function (el) {
            el.style.setProperty('margin-top', "calc(-".concat(el.scrollHeight, "px - var(--gap-sm))"));
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(_Teleport, { to: __props.teleport }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_TransitionGroup, {
                        name: "toast",
                        onLeave: _unref(leave)
                    }, {
                        default: _withCtx(function () { return [
                            _renderSlot(_ctx.$slots, "default")
                        ]; }),
                        _: 3 /* FORWARDED */
                    }, 8 /* PROPS */, ["onLeave"])
                ])
            ], 8 /* PROPS */, ["to"]));
        };
    }
});
